// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"placeholder"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V21H3V3Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3.5 12.5L12.5 3.5H20.5L3.5 20.5V12.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M20.5 11.5L11.5 20.5H20.5V11.5Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12.5 3.5L3.5 12.5M11.5 20.5L20.5 11.5M20.5 3.5L3.5 20.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3H21V21H3V3Z","strokeWidth":"props.strokeWidth"}}]}]};

const PlaceholderIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'placeholder',
    ref,
    icon: element,
  },
));

PlaceholderIcon.displayName = 'PlaceholderIcon';

export default PlaceholderIcon;
